export const getIsTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};
